export const STYLETRON_SHEET_CLASS_NAME = '_styletron_hydrate_';

export const STYLETRON_CLASS_PREFIX = '-';
